<template>
  <!-- One cell of a table group (see tableGroup.vue). Renders the td itself to keep the grid aligned. -->
  <td v-if="!relevant" class="cell-not-relevant"></td>
  <td v-else :class="cellClass">
    <b-form-input v-if="inputType=='number'"
      :id="elId"
      type="number"
      inputmode="decimal"
      size="sm"
      class="cell-input"
      v-model="myValue"
      :readonly="readonly"
      ></b-form-input>
    <b-form-input v-else
      :id="elId"
      type="text"
      size="sm"
      class="cell-input"
      v-model="myValue"
      :readonly="readonly"
      ></b-form-input>
  </td>
</template>

<script>
import base from './_baseInput.js'
import formUtils from '../../utils/form_utils.js'
import cellTypes from './subInput/tableCellTypes.js'

export default {
  name:'ITableCell',
  mixins:[base],
  computed:{
    inputType(){
      // html input type - the supported definition types are in tableCellTypes.js,
      // the parent table validates them before rendering any cell.
      return cellTypes[this.config.type] || 'text'
    },
    cellClass(){
      // background of the cell following the status, equivalent of input_class for a normal input.
      const inputClass = formUtils.status?.[this.status]?.input_class || ''
      if(inputClass.indexOf('alert-success')>-1){
        return 'table-success'
      }
      if(inputClass.indexOf('alert-warning')>-1){
        return 'table-warning'
      }
      if(inputClass.indexOf('alert-danger')>-1){
        return 'table-danger'
      }
      return '' // secondary (empty, not required) stays neutral
    },
  },
  methods:{
    formatEmitValue(){
      // save the numbers as numbers and not as the string returned by the input.
      if(this.inputType!='number'){
        return this.myValue
      }
      if(this.myValue===null || this.myValue===undefined || this.myValue===''){
        return null
      }
      if(this.config.type=='integer'){
        return Math.round(+this.myValue)
      }
      return +this.myValue
    },
  },
}
</script>

<style scoped>
.cell-not-relevant{
  background-color: #e9ecef;
  background-image: repeating-linear-gradient(45deg, transparent, transparent 4px, rgba(0,0,0,0.06) 4px, rgba(0,0,0,0.06) 8px);
}
.cell-input{
  min-width: 4.5rem;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  text-align: center;
}
/* the spinners take too much room in a cell */
.cell-input::-webkit-outer-spin-button,
.cell-input::-webkit-inner-spin-button{
  -webkit-appearance: none;
  margin: 0;
}
.cell-input[type=number]{
  -moz-appearance: textfield;
}
</style>
